import { DataTable as DataTableRenderer } from '@/components/data-table/DataTable';
import { PaginationFooter } from '@/components/data-table/PaginationFooter';
import {
  ColumnDef,
  getCoreRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  SortingState,
  useReactTable,
} from '@tanstack/react-table';
import { useState } from 'react';

interface DataTableProps<TData, TValue> {
  columns: ColumnDef<TData, TValue>[];
  data: TData[];
}

export function DataTable<TData, TValue>({
  columns,
  data,
}: DataTableProps<TData, TValue>) {
  const [sorting, setSorting] = useState<SortingState>([]);

  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    onSortingChange: setSorting,
    getSortedRowModel: getSortedRowModel(),
    state: {
      sorting,
    },
  });

  const rowCount = table.getFilteredRowModel().rows.length;

  return (
    <div className="space-y-4">
      <DataTableRenderer table={table} emptyMessage="Aucun plan trouvé." />
      <PaginationFooter
        page={table.getState().pagination.pageIndex + 1}
        pageCount={Math.max(1, table.getPageCount())}
        summary={`${rowCount} forfait${rowCount > 1 ? 's' : ''}`}
        pageSize={table.getState().pagination.pageSize}
        onPageSizeChange={(size) => table.setPageSize(size)}
        onPageChange={(page) => table.setPageIndex(page - 1)}
      />
    </div>
  );
}
